module.exports = __webpack_public_path__ + "img/sauce_du_chef.0d9793e3.png";